import { useDataProvider } from "react-admin";
import { Box, Typography, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";

const RankingSummary = props => {
  const { specialityId, rankingUrl } = props;

  const dataProvider = useDataProvider();
  const [summary, setSummary] = useState();

  useEffect(() => {
    const fetchSummary = async () => {
      var { data } = await dataProvider.getOne(`${rankingUrl}/summary`, { id: specialityId });
      setSummary(data);
    };

    fetchSummary();
  }, [dataProvider, rankingUrl, specialityId]);

  if (!summary) {
    return null;
  }

  return (
    <Box
      display="flex"
      justifyContent="space-around"
      mt={2}
    >
      {["accepted", "notAccepted"].map(category => (
        <Box
          key={category}
          textAlign="center"
        >
          <Typography variant="subtitle1">{category === "accepted" ? "Приети" : "Неприети"}</Typography>
          <Tooltip
            arrow
            title={
              <Box>
                <Typography variant="body2">Мъже: {summary[category].male}</Typography>
                <Typography variant="body2">Жени: {summary[category].female}</Typography>
                <Typography variant="body2">С преференции: {summary[category].priority}</Typography>
              </Box>
            }
          >
            <Box
              sx={{
                display: "inline-block",
                cursor: "pointer",
              }}
            >
              <Typography variant="h5">{summary[category].total}</Typography>
            </Box>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

export default RankingSummary;
